import $ from "jquery";

const availableJobsSticky = {
  variables: {
    sectionElem: $(".availableJobs--sticky-section"),
    isSticky: false,
    stickyThreshold: 0,
    availableJobHeading: $(".available-job__heading"),
    jobCtaSize: $(".job-cta")

  },
  methods: {
    calculateStickyPoint: function () {
      availableJobsSticky.variables.stickyThreshold =
        $(window).height() -
        availableJobsSticky.variables.sectionElem.outerHeight();
    },

    handleTitleFont: function() {
      const availableJobTitle = availableJobsSticky.variables.availableJobHeading;
      const desktopFontTitle = availableJobTitle.data('desktop-font-title');
      const mobileFontTitle = availableJobTitle.data('mobile-font-title');

      const availableJobCta = availableJobsSticky.variables.jobCtaSize;
      const desktopFontCta = availableJobCta.data('desktop-font-cta');
      const mobileFontCta = availableJobCta.data('mobile-font-cta');

            const width = window.innerWidth;
            let fontSize = desktopFontTitle;
            let fontSizeCta = desktopFontCta;
            if (width <= 576) {
                fontSize = mobileFontTitle;
                fontSizeCta = mobileFontCta;
            }

            availableJobTitle.css('font-size', `${fontSize}px`);
            availableJobTitle.find('*').css('font-size', `${fontSize}px`);
            availableJobCta.css('font-size',`${fontSizeCta}px`);

            // Apply inline color to all child elements to override RTE tag CSS
            const titleColor = availableJobTitle[0] && availableJobTitle[0].style.color;
            if (titleColor) {
                availableJobTitle.find('*').css('color', titleColor);
            }

        },

    handleScroll: function () {
      const $stickyElement = $(".blog-banner, .pdp-banner, .banner, .genericContainer");
      const $availableJobs = availableJobsSticky.variables.sectionElem;
      const windowTop = $(window).scrollTop();
      const firstFoldThreshold = $(window).height();

      if ($stickyElement.length > 0) {
        const stickyTop = $stickyElement.offset().top;

        if (windowTop >= stickyTop && windowTop > firstFoldThreshold) {
          $availableJobs.addClass("availableJobs--sticky");
          availableJobsSticky.variables.isSticky = true;

          if ($(window).width() <= 768) {
            $availableJobs.css("bottom", "0px");
            if ($("#scrollTop").length > 0) {
              $("#scrollTop").css("bottom", "9.875rem");
            }
          }
        } else {
          availableJobsSticky.variables.isSticky = false;
          $availableJobs.removeClass("availableJobs--sticky");

          if ($(window).width() <= 768) {
            $availableJobs.css("bottom", "0px");
            if ($("#scrollTop").length > 0) {
              $("#scrollTop").css("bottom", "");
            }
          }
        }
      } else {
        if (windowTop > firstFoldThreshold) {
          $availableJobs.addClass("availableJobs--sticky");
          availableJobsSticky.variables.isSticky = true;

          if ($(window).width() <= 768) {
            $availableJobs.css("bottom", "0px");
            if ($("#scrollTop").length > 0) {
              $("#scrollTop").css("bottom", "9.875rem");
            }
          }
        } else {
          availableJobsSticky.variables.isSticky = false;
          $availableJobs.removeClass("availableJobs--sticky");
        }
      }
    },

    adjustForScreenSize: function () {
      if ($(window).width() <= 768) {
        availableJobsSticky.variables.sectionElem.css("bottom", "0px");

        if ($("#scrollTop").length > 0) {
          $("#scrollTop").css("bottom", "");
        }
      }
    },

    init: function () {
      availableJobsSticky.variables.sectionElem = $(".availableJobs--sticky-section");
      availableJobsSticky.variables.availableJobHeading = $(".available-job__heading");
      availableJobsSticky.variables.jobCtaSize = $(".job-cta");
      availableJobsSticky.methods.calculateStickyPoint();
      availableJobsSticky.methods.handleTitleFont();

      // R4 perf: throttle scroll/resize handling to at most once per paint
      // via rAF, matching the established pattern in header.js/quickLinks.js.
      let scrollTicking = false;
      $(window).on("scroll", function () {
        if (scrollTicking) {return;}
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          availableJobsSticky.methods.handleScroll();
          scrollTicking = false;
        });
      });

      let resizeTicking = false;
      $(window).on("resize", function () {
        if (resizeTicking) {return;}
        resizeTicking = true;
        window.requestAnimationFrame(function () {
          availableJobsSticky.methods.handleTitleFont();
          resizeTicking = false;
        });
      });

      availableJobsSticky.methods.adjustForScreenSize();
    },
  },
};

const availableJobs = {
  variable: {
    url: window.location.href,
  },
  methods: {
    viewPlanButtonClickHandler: function () {
      $(document).on(
        "click",
        ".availableJobs__section .chli_btn--primary",
        function () {
          if ($(this).closest(".availableJobs__section").length) {
            let $link = $(this).find('a').first();
            let href = $link.attr("href");
            if(!href)
             {return;}
            var buttonTitle = $(this)
              .find("span")
              .first()
              .text()
              .replace(/\n/g, "")
              .trim();
            var obj = availableJobs.methods.dataLayerObj(buttonTitle);
            createDataLayer("buttonClick", obj);
          }
        }
      );
    },

    dataLayerObj: function (e) {
      var obj = {
        articleName: "",
        blogCategory: "",
        blogPageCategory: "",
        buttonText: e ? e : "",
        pageSection: "Bottom Sticky",
        pageType:
          document.querySelector("meta[name='template']").content ==
          "chli-base-page-template"
            ? availableJobs.variable.url.includes("blog")
              ? "Blogs"
              : availableJobs.variable.url.substring(
                  availableJobs.variable.url.indexOf(".com/"),
                  availableJobs.variable.url.lastIndexOf("/") === ".com"
                ) &&
                !availableJobs.variable.url
                  .substring(
                    availableJobs.variable.url.indexOf(".com/"),
                    availableJobs.variable.url.length - 1
                  )
                  .includes("/")
              ? "Home"
              : "Other Pages"
            : "Blog Details Page",
        planOption: "",
        productCategory: "",
        productName: "",
        question: "",
        source: "",
        searchTerm: "",
        videoTitle: "",
        bannerName: "",
      };
      return obj;
    },
  },
};

$(document).ready(function () {
  availableJobs.methods.viewPlanButtonClickHandler();
  if ($(".availableJobs--sticky-section").length > 0) {
    availableJobsSticky.methods.init();
  }
});
